module.exports = __webpack_public_path__ + "static/img/base-con-img.46315f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeroCode/base-con-img.svg
// module id = qv0q
// module chunks = 0